import { jsx as e } from "react/jsx-runtime";
import { useState as o, useRef as t, useEffect as r } from "react";
import { DatePicker as n } from "@progress/kendo-react-dateinputs";
import "@progress/kendo-theme-default/dist/all.css";
import { styled as a } from "@mui/joy";
import { KendoDatePickerProvider as s } from "./KendoDatePickerProvider.js";
import u from "./components/CustomCalendar.js";
import { CustomToggleButton as m } from "./components/CustomToggleButton.js";
import { Wrapper as i } from "./components/styled.js";
import { excludeForwardProps as l } from "../../utils/excludeForwardProps.js";
const d = { year: "РРРР", month: "ММ", day: "ДД", hour: "г", minute: "м", second: "с" }, c = a(n, { shouldForwardProp: l(["enableMouseWheel", "onOpen", "allowCaretMode"]) })``, p = ({ autoFocus: n2, views: a2, value: l2, format: p2, isInvalid: f, onChange: v = () => {
}, onOpen: h = () => {
}, onFocus: g = () => {
}, onBlur: C = () => {
}, onClose: w = () => {
}, minDate: j, maxDate: x, disabled: P, inputRef: b }) => {
  const [k, y] = o(false), [F, B] = o(false), D = t(null);
  r(() => {
    const e2 = (e3) => {
      const o2 = document.querySelector(".k-datepicker-popup");
      D.current && o2 && !D.current.contains(e3.target) && !o2.contains(e3.target) && (B(false), y(false));
    };
    return document.addEventListener("mousedown", e2), () => document.removeEventListener("mousedown", e2);
  }, []), r(() => {
    var _a;
    if (!b) return;
    const e2 = (_a = D.current) == null ? void 0 : _a.querySelector("input");
    e2 && (b.current = e2);
  }, [b]);
  return e(s, { value: { views: a2 }, children: e(i, { focus: k, ref: D, children: e(c, { autoFocus: n2, value: l2, show: F, tabIndex: 0, onFocus: () => {
    y(true), g == null ? void 0 : g();
  }, onBlur: () => {
    y(false), C == null ? void 0 : C();
  }, size: "medium", formatPlaceholder: d, format: p2, valid: !f, onChange: (e2) => {
    return o2 = e2.value, v(o2), void B(false);
    var o2;
  }, onPasteCapture: (e2) => {
    e2.preventDefault(), e2.stopPropagation();
  }, onOpen: h, onClose: w, toggleButton: (o2) => e(m, { ...o2, tabIndex: -1, onClick: () => B((e2) => !e2) }), min: j, max: x, calendar: u, disabled: P, enableMouseWheel: false }) }) });
};
export {
  p as KendoDatePicker
};
//# sourceMappingURL=index.js.map
